import { fg } from '@confluence/feature-gating';

export const isMeetingRecorderEligibilityEnabled = (): boolean =>
	fg('twcg-2202-loom-meeting-nudge-ht-gate') || fg('twcg-2202-loom-meeting-nudge-lt-gate');
